export default __webpack_public_path__ + "static/media/landing.e3dc5933.jpg";